import { getImageFromS3 } from '../imageService';

export const virtualTourChallenge = [
  {
    title: `Від <b>першого листка</b> до <br> продукту високої якості`,
    description:
      'Пройди віртуальну екскурсію та дізнайся, як виробляють якісні сигарети.',
    image: getImageFromS3('/images/virtual-tour-first-cut-challenge/1.gif'),
    roadImage: getImageFromS3('/images/virtual-tour-first-cut-challenge/road1.png')
  },
  {
    title: `Першим етапом є <br> <b>вирощування тютюну</b>`,
    description:
      'Спочатку на полях висівають тютюнове насіння.\n' +
      'А вже за кілька місяців рослини збирають вручну або механічно.',
    image: getImageFromS3('/images/virtual-tour-first-cut-challenge/2.gif'),
    roadImage: getImageFromS3('/images/virtual-tour-first-cut-challenge/road2.png')
  },
  {
    title: `Далі йде <b>сушіння<br> тютюнового листя</b>`,
    description:
      'Є кілька видів сушіння: на повітрі, у спеціальних сушарках, над димом чи під сонцем.\n' +
      'Від цього залежатиме смак, аромат і навіть міцність майбутнього продукту.',
    image: getImageFromS3('/images/virtual-tour-first-cut-challenge/3.gif'),
    roadImage: getImageFromS3('/images/virtual-tour-first-cut-challenge/road2.png')
  },
  {
    title: `Третій крок – <b>ферментація</b>`,
    description: `Листя "відпочиває" при контрольованій температурі та вологості.\n' +
      'Це прибирає зайву гіркоту, робить смак м'якшим та розвиває аромат.`,
    image: getImageFromS3('/images/virtual-tour-first-cut-challenge/4.gif'),
    roadImage: getImageFromS3('/images/virtual-tour-first-cut-challenge/road2.png')
  },
  {
    title: `Наступним йде <b>подрібнення<br> та купажування</b>`,
    description: `Листя "відпочиває" при контрольованій температурі та вологості.\n Це прибирає зайву гіркоту, робить смак м'якшим та розвиває аромат.`,
    image: getImageFromS3('/images/virtual-tour-first-cut-challenge/5.gif'),
    roadImage: getImageFromS3('/images/virtual-tour-first-cut-challenge/road2.png')
  },
  {
    title: `Нарешті <b>виробництво</b>!`,
    description:
      'Подрібнений тютюн надходить на автоматизовану лінію. Його загортають у спеціальний папір із фільтром.\n' +
      'Далі — нарізка на окремі сигарети та контроль якості.',
    image: getImageFromS3('/images/virtual-tour-first-cut-challenge/6.gif'),
    roadImage: getImageFromS3('/images/virtual-tour-first-cut-challenge/road2.png')
  },
  {
    title: `Останній етап — <b>пакування<br> та дистрибуція</b>`,
    description:
      'Сигарети фасують у пачки та блоки.\n' +
      'Додають елементи бренду та відправляють у точки продажу по всьому світу.',
    image: getImageFromS3('/images/virtual-tour-first-cut-challenge/7.gif'),
    roadImage: getImageFromS3('/images/virtual-tour-first-cut-challenge/road2.png')
  }
];
